import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminPromotion } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminPromotionsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/promotions`;

  constructor(private http: HttpClient) {}

  getPromotions(): Observable<PaginatedResponse<AdminPromotion>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  createPromotion(data: Partial<AdminPromotion>): Observable<AdminPromotion> {
    return this.http.post<ApiResponse<AdminPromotion>>(this.baseUrl, data).pipe(
      map(res => res.data)
    );
  }

  updatePromotion(id: number, data: Partial<AdminPromotion>): Observable<AdminPromotion> {
    return this.http.put<ApiResponse<AdminPromotion>>(`${this.baseUrl}/${id}`, data).pipe(
      map(res => res.data)
    );
  }

  deletePromotion(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
